/* eslint-disable */
// @ts-nocheck

import { ChevronDown } from 'lucide-react'
import { useState } from 'react'

import { CurrencyDollarIcon } from '@heroicons/react/24/outline'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { cn } from '@/lib/utils'

interface RangeFilterProps {
  title: string
  _placeholder?: string
  valueFrom: string
  valueTo: string
  onValueFromChange: (_value: string) => void
  onValueToChange: (_value: string) => void
  icon?: React.ReactNode
  className?: string
  currency?: boolean
}

export const RangeFilter = ({
  title,
  _placeholder = 'Seleccionar rango...',
  valueFrom,
  valueTo,
  onValueFromChange,
  onValueToChange,
  icon,
  className,
  currency = false,
}: RangeFilterProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const hasActiveRange = valueFrom || valueTo

  const clearRange = () => {
    onValueFromChange('')
    onValueToChange('')
  }

  const formatValue = (value: string) => {
    if (!value) return ''
    if (currency) {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
      }).format(parseFloat(value))
    }
    return value
  }

  const getDisplayText = () => {
    if (valueFrom && valueTo) {
      return `${formatValue(valueFrom)} - ${formatValue(valueTo)}`
    } else if (valueFrom) {
      return `Desde ${formatValue(valueFrom)}`
    } else if (valueTo) {
      return `Hasta ${formatValue(valueTo)}`
    }
    return title
  }

  const getActiveCount = () => {
    let count = 0
    if (valueFrom) count++
    if (valueTo) count++
    return count
  }

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <Button
          aria-label={title}
          className={cn('gap-1.5', className)}
          variant="outline"
        >
          {icon || <CurrencyDollarIcon className="h-4 w-4" />}
          <span>{getDisplayText()}</span>
          <ChevronDown className="h-4 w-4 opacity-50" />
          {hasActiveRange && (
            <Badge className="ml-1 rounded-full px-1.5" variant="secondary">
              {getActiveCount()}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent align="start" className="w-80 p-0">
        <div className="space-y-4 p-4">
          <div className="space-y-2">
            <h4 className="font-medium leading-none">{title}</h4>
            <p className="text-sm text-muted-foreground">
              Selecciona un rango de valores
            </p>
          </div>

          <div className="space-y-3">
            <div>
              <label className="mb-1 block text-xs font-medium text-gray-700">
                Desde
              </label>
              <input
                className="w-full rounded border border-gray-300 px-2 py-1 text-xs"
                onChange={(e) => onValueFromChange(e.target.value)}
                placeholder="0.00"
                step="0.01"
                type="number"
                value={valueFrom}
              />
            </div>

            <div>
              <label className="mb-1 block text-xs font-medium text-gray-700">
                Hasta
              </label>
              <input
                className="w-full rounded border border-gray-300 px-2 py-1 text-xs"
                onChange={(e) => onValueToChange(e.target.value)}
                placeholder="0.00"
                step="0.01"
                type="number"
                value={valueTo}
              />
            </div>
          </div>

          {hasActiveRange && (
            <div className="flex justify-between">
              <Button
                className="text-xs"
                onClick={clearRange}
                size="sm"
                variant="outline"
              >
                Limpiar
              </Button>
              <Button
                className="text-xs"
                onClick={() => setIsOpen(false)}
                size="sm"
              >
                Aplicar
              </Button>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  )
}
